import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import { sliderService } from '../../services/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faNewspaper, 
    faUsers, 
    faTrophy, 
    faHandshake,
    faArrowRight 
} from '@fortawesome/free-solid-svg-icons';

const Home = () => {
    const [sliders, setSliders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchSliders();
    }, []);

    const fetchSliders = async () => {
        try {
            const response = await sliderService.getAll();
            setSliders(response.data.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching sliders:', error);
            setLoading(false);
            // Fallback data
            setSliders([
                {
                    id: 1,
                    title: '',
                    subtitle: '',
                    image: 'assets/img/home-slider/banner1.png',
                },
                {
                    id: 2,
                    title: '',
                    subtitle: '',
                    image: 'assets/img/home-slider/banner2.png',
                }
            ]);
        }
    };

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true,
        arrows: true,
        fade: true,
    };

    const features = [
        {
            icon: faNewspaper,
            title: 'Media Excellence',
            description: 'Promoting excellence in journalism and media practice'
        },
        {
            icon: faUsers,
            title: 'Professional Network',
            description: 'Connect with media professionals across Karnataka'
        },
        {
            icon: faTrophy,
            title: 'Awards & Recognition',
            description: 'Recognizing outstanding contributions to media'
        },
        {
            icon: faHandshake,
            title: 'Partnerships',
            description: 'Building partnerships for media development'
        }
    ];

    if (loading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <>
            {/* Hero Slider */}
            <section className="hero-slider">
    <Slider {...sliderSettings}>
        {sliders.map((slider) => (
            <div key={slider.id} className="slider-slide">
                <div
                    className="slider-item"
                    style={{
                        backgroundImage: `url(${slider.image})`,
                    }}
                >
                    {/* Dark overlay */}
                    {/* <div className="slider-overlay"></div> */}

                    {/* Slider content */}
                    <div className="slider-content">
                        <h1 className="display-3 fw-bold mb-4">
                            {slider.title}
                        </h1>

                        <p className="lead mb-4">
                            {slider.subtitle}
                        </p>

                        {slider.link && (
                            <Button
                                as="a"
                                href={slider.link}
                                variant="primary"
                                size="lg"
                                className="rounded-pill px-5"
                            >
                                Learn More
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        ))}
    </Slider>
</section>

            {/* Features Section */}
            <section className="py-5">
                <Container>
                    <Row className="text-center mb-5">
                        <Col>
                            <h2 className="display-4 fw-bold">Why Indian News Paper & Media Association?</h2>
                            <p className="lead text-muted">Empowering media professionals for a better tomorrow</p>
                        </Col>
                    </Row>
                    <Row>
                        {features.map((feature, index) => (
                            <Col md={3} key={index} className="mb-4">
                                <Card className="h-100 text-center shadow-sm border-0">
                                    <Card.Body className="py-4">
                                        <div className="feature-icon mb-3">
                                            <FontAwesomeIcon 
                                                icon={feature.icon} 
                                                size="3x" 
                                                className="text-primary"
                                            />
                                        </div>
                                        <h5 className="fw-bold">{feature.title}</h5>
                                        <p className="text-muted">{feature.description}</p>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* CTA Section */}
            <section className="py-5 bg-primary text-white">
                <Container>
                    <Row className="align-items-center text-center text-md-start">
                        <Col md={8}>
                            <h2 className="fw-bold mb-3">Ready to Join Us?</h2>
                            <p className="lead mb-0">
                                Become a member and be part of INMA (Indian News Paper & Media Association)
                            </p>
                        </Col>
                        <Col md={4} className="text-center text-md-end mt-3 mt-md-0">
                            <Button 
                                as={Link} 
                                to="/membership" 
                                variant="light" 
                                size="lg"
                                className="rounded-pill px-4"
                            >
                                Join Now <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default Home;